/**
 * Normalizes configuration data based on the specified app type
 *
 * @param rawConfig - The raw configuration object to be normalized
 * @returns A normalized Config object with standardized structure
 */

export const normalizeLibreSharingConfig = rawConfig => {
  const config = {
    ...rawConfig,
    validation: {
      identity: rawConfig.validation.identity,
      api: {
        patient: {
          firstName: {
            stringMaxLength: rawConfig.validation.libreSharingApi.patient.firstName.stringMaxLength
          },
          lastName: {
            stringMaxLength: rawConfig.validation.libreSharingApi.patient.lastName.stringMaxLength
          }
        }
      }
    }
  };
  return config;
};
export const normalizeLibreConfig = rawConfig => {
  const {
    libreApi
  } = rawConfig.validation;

  /**
   * Add backward compatibility
   *
   * Nested patient shape is 3.26; flat max-length fields are 3.27 (Remove in 3.28)
   *
   */
  const firstNameMaxLength = libreApi.firstNameMaxLength ?? libreApi.patient?.firstName.stringMaxLength ?? 40;
  const lastNameMaxLength = libreApi.lastNameMaxLength ?? libreApi.patient?.lastName.stringMaxLength ?? 80;
  return {
    adultAges: rawConfig.adultAges,
    connectedAppsSupportedCountries: rawConfig.connectedAppsSupportedCountries,
    i18n: rawConfig.i18n,
    supportedCountries: rawConfig.supportedCountries,
    countries: rawConfig.countries,
    languages: rawConfig.languages,
    libreApiUrl: rawConfig.libreApiUrl,
    libreApiCountryUrls: rawConfig.libreApiCountryUrls,
    documentsUrl: rawConfig.documentUrls.files,
    documents: rawConfig.documentPaths.files,
    validation: {
      identity: rawConfig.validation.identity,
      api: {
        patient: {
          firstName: {
            stringMaxLength: firstNameMaxLength
          },
          lastName: {
            stringMaxLength: lastNameMaxLength
          }
        }
      }
    }
  };
};